import React, { useEffect } from "react";
import "../styles/SedeSessionNotice.css";

function SedeSessionNotice({ notice, onClose }) {
    useEffect(() => {
        if (!notice) return undefined;

        const onKeyDown = (event) => {
            if (event.key === "Escape") onClose?.();
        };

        window.addEventListener("keydown", onKeyDown);
        return () => window.removeEventListener("keydown", onKeyDown);
    }, [notice, onClose]);

    if (!notice) return null;

    const isChange = notice.type === "change";
    const advisorName = notice.fullName || notice.name || "Asesor";
    const currentSede = notice.sedeName || "Sin sede asignada";

    return (
        <div className="sedeSessionOverlay" role="presentation">
            <section
                className="sedeSessionCard"
                role="dialog"
                aria-modal="true"
                aria-labelledby="sede-session-title"
                aria-describedby="sede-session-description"
            >
                <div className={`sedeSessionIcon ${isChange ? "is-change" : "is-login"}`} aria-hidden="true">
                    {isChange ? (
                        <svg viewBox="0 0 24 24" focusable="false">
                            <path d="M7 7h11l-2.8-2.8M17 17H6l2.8 2.8M18 7l-3-3m3 3-3 3M6 17l3 3m-3-3 3-3" />
                        </svg>
                    ) : (
                        <svg viewBox="0 0 24 24" focusable="false">
                            <path d="M12 21s7-5.2 7-12A7 7 0 0 0 5 9c0 6.8 7 12 7 12Z" />
                            <circle cx="12" cy="9" r="2.4" />
                        </svg>
                    )}
                </div>

                <div className="sedeSessionHeading">
                    <span className="sedeSessionEyebrow">
                        {isChange ? "Actualización de sede" : "Sede de trabajo confirmada"}
                    </span>
                    <h2 id="sede-session-title">
                        {isChange ? "Tu sede fue actualizada" : `Bienvenido, ${advisorName}`}
                    </h2>
                </div>

                {isChange ? (
                    <div id="sede-session-description" className="sedeSessionContent">
                        <p>
                            <strong>{advisorName}</strong>, el administrador actualizó tu sede de trabajo mientras tu sesión estaba activa.
                        </p>

                        <div className="sedeSessionTransition" aria-label="Cambio de sede">
                            <div className="sedeSessionPlace is-previous">
                                <span>Anterior</span>
                                <strong>{notice.previousSedeName || "Sede anterior"}</strong>
                            </div>
                            <div className="sedeSessionArrow" aria-hidden="true">→</div>
                            <div className="sedeSessionPlace is-current">
                                <span>Nueva sede</span>
                                <strong>{currentSede}</strong>
                            </div>
                        </div>

                        <div className="sedeSessionInfoBox">
                            Ahora estás trabajando en <strong>{currentSede}</strong>. Las operaciones nuevas del sistema utilizarán esta sede.
                        </div>
                    </div>
                ) : (
                    <div id="sede-session-description" className="sedeSessionContent">
                        <p>
                            Estás iniciando sesión como <strong>{advisorName}</strong> en la siguiente sede:
                        </p>

                        <div className="sedeSessionCurrentSede">
                            <span>Sede asignada</span>
                            <strong>{currentSede}</strong>
                            {notice.sedeLocation ? <small>{notice.sedeLocation}</small> : null}
                        </div>

                        <div className="sedeSessionWarning">
                            <strong>¿La sede no es correcta?</strong>
                            <span>Contacta a Frank para solicitar el cambio a la sede correspondiente.</span>
                        </div>
                    </div>
                )}

                <div className="sedeSessionFooter">
                    <button type="button" className="sedeSessionConfirm" onClick={onClose} autoFocus>
                        Entendido
                    </button>
                </div>
            </section>
        </div>
    );
}

export default SedeSessionNotice;
